import { CircleHelp } from 'lucide-react';
import { useState } from 'react';

import { cx } from '@/lib/cx';
import { Dica } from '@/ui/primitives/tooltip';

interface DicaAjudaProps {
  /** Nome acessível do botão: "Sobre a coluna Direção". */
  rotulo: string;
  /** A explicação, curta (uma ou duas frases). */
  texto: string;
  className?: string;
}

/**
 * Ícone "?" que explica um termo ao lado (cabeçalho de coluna, rótulo de campo). Abre por hover,
 * foco (Tab) e também por toque/clique — a dica do Radix sozinha não abre no celular. Esc ou tocar
 * fora fecha. O texto vira a descrição acessível do botão enquanto aberto.
 */
export function DicaAjuda({ rotulo, texto, className }: DicaAjudaProps) {
  const [aberta, setAberta] = useState(false);
  return (
    <Dica texto={texto} aberta={aberta} aoMudar={setAberta}>
      <button
        type="button"
        aria-label={rotulo}
        // Impede o Radix de fechar no toque; o clique abaixo abre (e mantém aberta).
        onPointerDown={(e) => {
          e.preventDefault();
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setAberta(true);
        }}
        className={cx(
          'inline-grid size-5 shrink-0 cursor-help place-items-center rounded-full align-middle text-texto-fraco',
          'transition-colors duration-[var(--duracao-rapida)] hover:text-texto data-[state$=open]:text-marca',
          className,
        )}
      >
        <CircleHelp className="size-3.5" aria-hidden />
      </button>
    </Dica>
  );
}
